import { render } from "./SideBarDesktopCliente.vue?vue&type=template&id=29e3a029"
import script from "./SideBarDesktopCliente.vue?vue&type=script&lang=js"
export * from "./SideBarDesktopCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__